
document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('[data-mobile-nav]');

  if (!button || !menu) return;

  function closeMenu() {
    menu.setAttribute('hidden', '');
    button.setAttribute('aria-expanded', 'false');
  }

  button.addEventListener('click', function () {
    const isHidden = menu.hasAttribute('hidden');

    if (isHidden) {
      menu.removeAttribute('hidden');
    } else {
      menu.setAttribute('hidden', '');
    }

    button.setAttribute('aria-expanded', String(isHidden));
  });

  menu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !menu.hasAttribute('hidden')) {
      closeMenu();
      button.focus();
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 900 && !menu.hasAttribute('hidden')) {
      closeMenu();
    }
  });
});


/* V1.7 — remove old third-party "3 sauces / 20%" promo from product pages.
   The promo is injected externally and is not part of the Comasira's theme copy. */
(function () {
  function normalizeText(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isOldPromoText(text) {
    var t = normalizeText(text);
    return (
      t.indexOf('compra 3 salse') !== -1 ||
      t.indexOf('risparmia il 20%') !== -1 ||
      t.indexOf('risparmia il 20') !== -1 ||
      t.indexOf('spedizione gratuita compresa') !== -1
    );
  }

  function containsProtectedProductUI(node) {
    if (!node || !node.querySelector) return false;
    return !!node.querySelector(
      '.product-premium__add,' +
      '.product-premium__price-row,' +
      '.product-premium__shipping,' +
      '.product-premium__signature,' +
      '.product-premium__title'
    );
  }

  function hidePromoNode(node, root) {
    if (!node || node === root) return;

    var target = node;

    // Enlarge the hidden area only when the ancestor still looks exclusively
    // like the injected promotion. Never consume native product controls.
    for (var i = 0; i < 4; i++) {
      var parent = target.parentElement;
      if (!parent || parent === root) break;

      var parentText = normalizeText(parent.innerText || parent.textContent);
      if (
        isOldPromoText(parentText) &&
        parentText.length < 650 &&
        !containsProtectedProductUI(parent)
      ) {
        target = parent;
      } else {
        break;
      }
    }

    target.setAttribute('data-comasiras-hidden-old-promo', 'true');
    target.style.setProperty('display', 'none', 'important');
    target.style.setProperty('visibility', 'hidden', 'important');
    target.style.setProperty('height', '0', 'important');
    target.style.setProperty('min-height', '0', 'important');
    target.style.setProperty('margin', '0', 'important');
    target.style.setProperty('padding', '0', 'important');
    target.style.setProperty('overflow', 'hidden', 'important');
  }

  function removeOldProductPromo() {
    var root = document.querySelector('.product-premium__buy');
    if (!root) return;

    // The intended purchase column contains no iframes. Any iframe inserted
    // here is an external app widget and is suppressed.
    root.querySelectorAll('iframe').forEach(function (frame) {
      hidePromoNode(frame, root);
    });

    var nodes = root.querySelectorAll('*');
    nodes.forEach(function (node) {
      if (node.hasAttribute('data-comasiras-hidden-old-promo')) return;

      var text = normalizeText(node.innerText || node.textContent);
      if (!text || text.length > 700) return;

      if (isOldPromoText(text)) {
        hidePromoNode(node, root);
      }
    });
  }

  function startOldPromoGuard() {
    if (!document.querySelector('.product-premium')) return;

    removeOldProductPromo();

    // Some Shopify apps inject their widgets after page load.
    var observer = new MutationObserver(function () {
      removeOldProductPromo();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Extra delayed passes for slow third-party widgets.
    window.setTimeout(removeOldProductPromo, 500);
    window.setTimeout(removeOldProductPromo, 1500);
    window.setTimeout(removeOldProductPromo, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startOldPromoGuard);
  } else {
    startOldPromoGuard();
  }
})();
